<!-- 首页 -->
<template>
  <div class="home_layout">
    <img class="background" src="https://cdn.welove520.com/static/res/vue/playbay/bg.png"/>
    <div class="home">
      <img src="https://cdn.welove520.com/static/res/vue/playbay/homenew.png"/>
    </div>
    <div class="news">
      <p>NEWS | 公司大事记</p>
      <p>· 游戏研发团队攻克技术难关，公司获得多项研发成果 10-09</p>
      <p>· 招聘季发现角公司在各大高校招聘优秀人才 09-21</p>
      <p>· 发现角各核心团队建立完毕，游戏研发进入快车道 05-09</p>
      <p>· 专注于情侣互动娱乐产业的科技公司“发现角”成立，落户美丽北京 02-22</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {};
  },
  components: {},
  created() {
    // this.$store.dispatch('initTabName', 'home')
    this.$store.commit("changeTab", "home");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home_layout {
  position: relative;
}

.background {
  width: 100%;
  position: relative;
}

.home {
  position: absolute;
  width: 100%;
  top: 0;
  margin-top: 18%;
}

.home > img {
  width: 650px;
  display: block;
  margin: 0 auto;
}

.news {
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  position: absolute;
  bottom: 0;
  right: 0;
  margin-bottom: 50px;
  margin-right: 40px;
}

.news > p {
  font-size: 14px;
  color: white;
}

.news > p:nth-child(1) {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue